export const environment = {
  production: true,
  hmr: false,
  sessionTimeoutSec: 1800,
  // S3 Proxy disabled in production
  s3Proxy: {
    enabled: false,
    s3Url: '',
    proxyUrl: ''
  }
};
